/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-10 17:13:45
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title4 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import FormChart from './FormChart';

class P13 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],

      tableColumns: [],
      tableList: [],
    }
  }

  fillColor = (tableColumns) => {
    const border = `1px solid #000`;
    return tableColumns.map(item => {
      return {
        ...item,
        style: {
          ...item.style,
          height: 28,
          fontSize: 16,
          fontWeight: 500,
          textAlign: 'center',
          background: '#fff',
          color: '#000',
          borderBottom: border,
        },
        colStyle: (_, __, i) => {
          return {
            height: 28,
            fontSize: 16,
            fontWeight: 500,
            textAlign: 'center',
            borderLeft: i === 0 ? border : 'none',
            borderRight: border,
            borderBottom: border,
            background: '#fff',
          }
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;
    return (
      <Stage>
        <Title4 pageNumber="3.4">安踏VS竞品 | 重点媒体传播效果-<span className={s.titleHint}>新华社系</span></Title4>

        <div className={s.content}>
          <div contentEditable className={s.subTitle}>
            安踏在Q1、Q4发力较大，传播效果好于竞品；李宁在Q3传播声量更高
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ height: '100%' }}
                formContent={<FormChart onChange={values => this.setState({ ...values })} />}>
                <Chart options={setChart({ title: chartTitle, list: chartList, color: chartColorList })} />
              </TooltipDrawer>
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable
                  columns={this.fillColor(tableColumns)}
                  data={tableList}
                  style={{
                    boxShadow: 'none',
                  }}
                />
              </TooltipDrawer>
            </div>
            <div style={{ color: '#999', paddingLeft: 30 }}>*注：统计中，新华系子媒不含上海证券报、中国证券报；曝光条数包含站外转载数量。</div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P13);



// WEBPACK FOOTER //
// src/routes/visualChart/P13/index.js